import { createRef, useEffect, useState } from "react";
import { Form, TreeSelect } from "antd";

import { useProduct } from "hooks/useProduct";
import FormSubmitButton from "components/Common/FormSubmitButton";
import useFetch from "hooks/useFetch";

const { useForm } = Form;

const ProductDropdown = () => {
  const [form] = useForm();
  const formRef = createRef();
  const {
    responseData: productOptionsResponseData,
    doFetch: getProductOptions,
  } = useFetch("/products/getProductOptions", "GET", []);
  const { selectedProductIds, setSelectedProductIds } = useProduct();
  const [productSelectionsChanged, setProductSelectionsChanged] =
    useState(false);

  let productOptions = [];
  if (!!productOptionsResponseData.data) {
    productOptions = [
      {
        title: "All",
        value: -1,
        key: -1,
        children: productOptionsResponseData.data ?? [],
      },
    ];
  }

  const onProductsSelected = (values) => {
    setSelectedProductIds(values.product_ids);
    setProductSelectionsChanged(false);
  };

  useEffect(() => {
    getProductOptions();
  }, []);

  useEffect(() => {
    if (
      productOptions.length > 0 &&
      productOptions[0].children?.length > 0 &&
      form.getFieldValue("product_ids")?.length === 0
    ) {
      form.setFieldsValue({
        product_ids: [productOptions[0].children[0]?.value],
      });
      formRef.current.submit();
    }
  }, [form, formRef]);

  return (
    <>
      <Form
        name="product_selection_form"
        form={form}
        ref={formRef}
        initialValues={{
          product_ids: selectedProductIds,
        }}
        onFinish={onProductsSelected}
        layout="inline"
        requiredMark={false}
      >
        <Form.Item
          label="Products"
          name="product_ids"
          style={{ minWidth: "30rem", width: "60%" }}
          rules={[{ required: true }]}
        >
          <TreeSelect
            treeData={productOptions}
            onChange={() => setProductSelectionsChanged(true)}
            treeCheckable={true}
            showCheckedStrategy={TreeSelect.SHOW_PARENT}
            treeDefaultExpandAll={true}
            maxTagCount="responsive"
          />
        </Form.Item>
        <Form.Item>
          <FormSubmitButton
            form={form}
            label="Apply"
            disabled={!productSelectionsChanged}
          />
        </Form.Item>
      </Form>
    </>
  );
};

export default ProductDropdown;
